import React from "react";
import "moment/locale/zh-cn";
import style from "./index.module.scss";
import { useParams } from "react-router-dom";
import MessageList from "../../../components/WebIM/Components/MessageList";
import SendMsg from "../../../components/WebIM/Components/SendMsg";
import WebIMProvider from "../../../components/WebIM/Components/WebIMProvider";
import ChatHeader from "./Components/ChatHeader";

export default function ChatDetail() {
    const { sessionUid } = useParams<{ sessionUid: string }>();

    return (
        <div className={style.root}>
            <WebIMProvider initSession={sessionUid}>
                <ChatHeader sessionId={sessionUid} />

                <MessageList sessionId={sessionUid} />
                <SendMsg sessionId={sessionUid} />
            </WebIMProvider>
        </div>
    );
}
